export const ASPECT_RATIOS = {
    '16:9': { width: 16, height: 9, label: '16:9' },
    '9:16': { width: 9, height: 16, label: '9:16' },
    '1:1': { width: 1, height: 1, label: '1:1' },
    '4:5': { width: 4, height: 5, label: '4:5' },
    '4:3': { width: 4, height: 3, label: '4:3' },
    '3:2': { width: 3, height: 2, label: '3:2' },
    '2:1': { width: 2, height: 1, label: '2:1' },
    '2.35:1': { width: 2.35, height: 1, label: '2.35:1' },
    '2.39:1': { width: 2.39, height: 1, label: '2.39:1' },
    '21:9': { width: 21, height: 9, label: '21:9' },
};
export function aspectRatioOf(width, height) {
    if (height === 0)
        return 0;
    return width / height;
}
export function ratioLabel(ratio) {
    if (!Number.isFinite(ratio) || ratio <= 0)
        return `${ratio}`;
    const EPS = 1e-4;
    let m0 = 0;
    let n0 = 1;
    let m1 = 1;
    let n1 = 0;
    let x = ratio;
    for (let i = 0; i < 20; i++) {
        const a = Math.floor(x);
        const m2 = a * m1 + m0;
        const n2 = a * n1 + n0;
        m0 = m1;
        n0 = n1;
        m1 = m2;
        n1 = n2;
        if (Math.abs(x - a) < 1e-12 || Math.abs(ratio - m1 / n1) / ratio < EPS)
            break;
        x = 1 / (x - a);
    }
    return `${m1}:${n1}`;
}
export function resolutionFromAspectRatio(aspect, mode, value) {
    const ratio = aspectOfRatio(aspect);
    if (mode === 'width') {
        return { width: Math.round(value), height: Math.round(value / ratio) };
    }
    return { width: Math.round(value * ratio), height: Math.round(value) };
}
export function resolutionFromSize(size, targetRatio) {
    const current = aspectRatioOf(size.width, size.height);
    if (current > targetRatio) {
        return { width: size.width, height: Math.round(size.width / targetRatio) };
    }
    return { width: Math.round(size.height * targetRatio), height: size.height };
}
export function orientationOf(width, height) {
    if (width === height)
        return 'square';
    return width > height ? 'landscape' : 'portrait';
}
export function containsAspect(aspect, target) {
    return Math.abs(aspectOfRatio(aspect) - aspectOfRatio(target)) < 0.001;
}
function aspectOfRatio(a) {
    return aspectRatioOf(a.width, a.height);
}
//# sourceMappingURL=aspect-ratio.js.map